import BookNowButton from './BookNowButton';

export default BookNowButton;
